import { camelcaseKeys } from 'src/utils/camelize-keys';
import { decamelizeKeys } from 'src/utils/decamelize-keys';
import { removeReadOnlyFields } from 'src/utils/fieldNormalizers';

import { AssignedVideo, Video } from './_types';

export const normalizeAssignedVideo = (resource): AssignedVideo => {
  return camelcaseKeys(resource, { deep: true }) as AssignedVideo;
};

export const normalizeVideo = (resource): Video => {
  return camelcaseKeys(resource, { deep: true }) as Video;
};

export const denormalizeGroupVideo = (resource): any => {
  const video = decamelizeKeys(resource, { deep: true });

  removeReadOnlyFields(video, [
    'tags',
    'embed_url',
    'thumbnail_id',
    'thumbnail_preview',
    'input_type',
  ]);

  return video;
};

export const denormalizeVideo = (resource): any => {
  const video = decamelizeKeys(resource, { deep: true });

  removeReadOnlyFields(video, [
    'large_thumbnail_url',
    'thumbnail_preview',
    'video_id',
    'input_type',
    'uploaded_video',
  ]);

  return video;
};
